module.exports = __webpack_public_path__ + "static/img/female-bg-tr.301e7794.png";